import Title from "common/Typography/Title";
import React from "react";
import CaretDownOutlinedAnt from "@ant-design/icons/CaretDownOutlined";
import CaretUpOutlinedAnt from "@ant-design/icons/CaretUpOutlined";
import styled from "styled-components";
import useMedia from "utils/hooks/useMedia";
import { MOBILE_SEARCH } from "common/constants";
import { SortingOrder } from "@shared/types";

interface ColumnTitleProps {
  columnName: string;
  sortingBy: string;
  sortOrder: SortingOrder;
  onClick: () => void;
  titleSize: number;
}

const ColumnTitle: React.FC<ColumnTitleProps> = ({
  columnName,
  sortingBy,
  sortOrder,
  onClick,
  titleSize,
}) => {
  const isMobile = useMedia([`(max-width: ${MOBILE_SEARCH})`], [true], false);

  const getArrowDirection = (columnTitle: string) => {
    if (columnTitle !== sortingBy || sortOrder === SortingOrder.DESCEND)
      return <CaretDownOutlined $isMobile={isMobile} />;
    if (sortOrder === SortingOrder.ASCEND)
      return <CaretUpOutlined $isMobile={isMobile} />;
  };

  return (
    <ColumnTitleWrapper onClick={onClick}>
      <Title
        type={sortingBy === columnName ? "primary" : "secondary"}
        level={isMobile ? titleSize + 1 : titleSize}
        style={{
          fontWeight: sortingBy === columnName ? 600 : "",
        }}
      >
        {columnName}
      </Title>
      {getArrowDirection(columnName)}
    </ColumnTitleWrapper>
  );
};

export default ColumnTitle;

const ColumnTitleWrapper = styled.div`
  display: flex;
  align-items: center;
  cursor: pointer;
`;

const CaretDownOutlined = styled(CaretDownOutlinedAnt)<{ $isMobile: boolean }>`
  margin-left: ${(p) => (p.$isMobile ? "2px" : "4px")};
  color: ${(p) => p.theme.colors.secondaryGrey};
`;

const CaretUpOutlined = styled(CaretUpOutlinedAnt)<{ $isMobile: boolean }>`
  margin-left: ${(p) => (p.$isMobile ? "2px" : "4px")};
  color: ${(p) => p.theme.colors.secondaryGrey};
`;
